import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bh_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // God Mode: impersonation token (short-lived JWT), ignored by backend when
  // the caller isn't info@noordzuid.nl. Set when "Access Hub" is clicked.
  const impToken = localStorage.getItem("bh_imp_token");
  if (impToken) {
    config.headers = config.headers || {};
    config.headers["X-Impersonate-Token"] = impToken;
  }
  // Super-admin 2FA session token — only sent to /super-admin/* routes.
  const saToken = localStorage.getItem("bh_sa_token");
  if (saToken && typeof config.url === "string" && config.url.startsWith("/super-admin")) {
    config.headers = config.headers || {};
    config.headers["X-Super-Admin-Token"] = saToken;
  }
  return config;
});

// When the Super-Admin 2FA session expires mid-use, the backend returns 401
// with detail "2FA vereist". The SuperAdminLayout mounts a modal that listens
// for this event and prompts the admin to re-enter their TOTP code without
// losing their current tab/scroll position.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    try {
      const url = err?.config?.url || "";
      const status = err?.response?.status;
      const detail = err?.response?.data?.detail;
      if (status === 401 && detail === "2FA vereist" && url.startsWith("/super-admin")) {
        window.dispatchEvent(new CustomEvent("sa:reauth-required"));
      }
    } catch { /* ignore */ }
    return Promise.reject(err);
  }
);

export default api;

export function fileUrl(fileId, { download = false } = {}) {
  const token = localStorage.getItem("bh_token");
  const params = new URLSearchParams();
  if (download) params.set("download", "1");
  if (token) params.set("auth", token);
  const qs = params.toString();
  return `${API}/files/${fileId}${qs ? `?${qs}` : ""}`;
}
